/* eslint-disable */
import React, { useContext, useRef } from 'react';
import { useTheme } from '@emotion/react';
// import { css, StyleSheet } from 'aphrodite/no-important';
import { ThemeContext } from '../theme';
import { Chip } from './chip';

const ChipsContainer = React.forwardRef((props, ref) => {
  // const textInputRef = useRef();

  const context = useContext(ThemeContext);
  let chipContainer;
  const theme = useTheme();

  if (theme && theme.chipContainer) {
    chipContainer = theme.chipContainer;
  } else {
    chipContainer = context.theme.chipContainer;
  }

  const {
    borderWidth: chipContainerBorderWidth,
    borderColor: chipContainerBorderColor,
    background: chipContainerBackground,
    color: chipContainerColor,
    chipInputBackground
  } = chipContainer;

  // const handleOnChipClose = (id) => {
  //   props.onChipClose(id);
  // };

  const handleContainerClick = () => {
    if (ref && ref.current) {
      ref.current.focus();
    }
  };

  const handleOnKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (ref.current) {
        props.onChipAdd(ref.current.value);
        ref.current.value = '';
      }
    }
  };

  // Generating chips
  const chips = [];
  props.tags.forEach(el => {
    chips.push(
      <Chip
        id={el.id}
        // icon="fa fa-circle"
        icon={el.icon}
        iconClass={el.iconClass}
        text={el.text}
        onClose={props.onChipClose}
        showCloseIcon
      />
    );
  });

  return (
    <div
      onClick={handleContainerClick}
      style={{
        display: 'flex',
        flexFlow: 'row wrap',
        padding: '8px',
        width: '100%',
        borderBottom: `${chipContainerBorderWidth} solid ${chipContainerBorderColor}`,
        background: chipContainerBackground,
        borderTopLeftRadius: '5px',
        borderTopRightRadius: '5px'
      }}
    >
      {chips}
      <input
        ref={ref}
        type="text"
        onKeyPress={handleOnKeyPress}
        onChange={props.onChange}
        style={{
          outline: 'none',
          border: '0',
          background: chipInputBackground,
          color: chipContainerColor,
          caretColor: 'white',
          width: '120px',
          height: '32px',
          fontSize: '16px'
        }}
      />
    </div>
  );
});

// const ChipsContainer = (props) => {
//   const textInputRef = useRef();

//   const context = useContext(ThemeContext);
//   let chipContainer;
//   const theme = useTheme();

//   if (theme && theme.chipContainer) {
//     chipContainer = theme.chipContainer;
//   } else {
//     chipContainer = context.theme.chipContainer;
//   }

//   const {
//     borderWidth: chipContainerBorderWidth,
//     borderColor: chipContainerBorderColor,
//     background: chipContainerBackground,
//     color: chipContainerColor,
//     chipInputBackground
//   } = chipContainer;

//   // const handleOnChipClose = (id) => {
//   //   props.onChipClose(id);
//   // };

//   const handleContainerClick = () => {
//     if (textInputRef && textInputRef.current) {
//       textInputRef.current.focus();
//     }
//   };

//   const handleOnKeyPress = (e) => {
//     if (e.key === 'Enter') {
//       if (textInputRef.current) {
//         props.onChipAdd(textInputRef.current.value);
//         textInputRef.current.value = '';
//       }
//     }
//   };

//   // Generating chips
//   const chips = [];
//   props.tags.forEach(el => {
//     chips.push(
//       <Chip
//         id={el.id}
//         icon="fa fa-circle"
//         text={el.text}
//         onClose={props.onChipClose}
//         showCloseIcon
//       />
//     );
//   });

//   return (
//     <div
//       onClick={handleContainerClick}
//       style={{
//         display: 'flex',
//         flexFlow: 'row wrap',
//         padding: '8px',
//         width: '100%',
//         borderBottom: `${chipContainerBorderWidth} solid ${chipContainerBorderColor}`,
//         background: chipContainerBackground
//       }}
//     >
//       {chips}
//       <input
//         ref={textInputRef}
//         type="text"
//         onKeyPress={handleOnKeyPress}
//         style={{
//           outline: 'none',
//           border: '0',
//           background: chipInputBackground,
//           color: chipContainerColor,
//           caretColor: 'white',
//           width: '120px',
//           height: '32px',
//           fontSize: '12px'
//         }}
//       />
//     </div>
//   );
// };

export { ChipsContainer };
